import { JBaseApi } from '../base';
import { OF } from '../../util';
import { ApiWrapper, BaseMessagesOne, PagingResults, jObjectAutocomplete } from '../../types';
import { AutocompleteHierarchy, AutoCompleteList, jTaxonomyLittle, TaxonomyCreate } from './types';

export class JTaxonomyApi extends JBaseApi {
    /**
     * list all taxonomies (no pagination)
     */
    public list(): Promise<jTaxonomyLittle[]> {
        return this.network
            .post<jTaxonomyLittle[]>({
                o: 'taxonomy',
                f: 'list',
                format: 'raw-little',
            } as OF)
            .then((res) => {
                if (Array.isArray(res.result)) {
                    return res.result;
                }
                throw 'Bad response from backend';
            });
    }

    public create<T = jTaxonomyLittle>({
        format = 'raw-little',
        ...taxonomy
    }: TaxonomyCreate): Promise<ApiWrapper<T, BaseMessagesOne>> {
        return this.network.post<T, BaseMessagesOne>({
            o: 'taxonomy',
            f: 'create',
            format,
            ...taxonomy,
        } as OF);
    }

    /**
     * autocomplete return a list of tags
     * @param idTaxonomy taxonomy id
     * @param query search characters
     */
    public autocomplete(idTaxonomy: string, query: string) {
        return this.network.post<Array<jObjectAutocomplete>>({
            o: 'autocomplete',
            f: 'taxonomy',
            q: query,
            idTaxonomy,
            idToUri: false,
        } as OF);
    }

    public autocompleteList<T = jObjectAutocomplete>({ format = 'autocomplete', ...payload }: AutoCompleteList) {
        return this.network.post<PagingResults<T>>({
            o: 'objectListTaxonomy',
            f: 'concept',
            format,
            ...payload,
        } as OF);
    }

    public autocompleteHierarchy(payload: AutocompleteHierarchy) {
        return this.network.post<PagingResults<jObjectAutocomplete>>({
            o: 'objectListTaxonomyHierarchy',
            f: 'concept',
            ...payload,
        } as OF);
    }
}
